import { Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import { LK_URL } from '../config/links';

const footerLinks = {
  'О чемпионате': [
    { label: 'О нас', href: '/about' },
    { label: 'Направления', href: '/#directions' },
    { label: 'Этапы', href: '/#timeline' },
    { label: 'Правила', href: '/about#rules' },
  ],
  'Участникам': [
    { label: 'Регистрация', href: '/registration' },
    { label: 'Личный кабинет', href: LK_URL },
    { label: 'FAQ', href: '/faq' },
    { label: 'Положение (PDF)', href: '/documents/regulation/polozhenie_2026-2027.pdf' },
  ],
  'Партнёрам': [
    { label: 'Стать партнёром', href: '/partners#join' },
    { label: 'Текущие партнёры', href: '/partners' },
    { label: 'Контакты', href: '/contacts' },
  ],
};

const VkIcon = ({ size = 20 }: { size?: number }) => (
  <img src="/images/vk.svg" alt="VK" width={size} height={size} className="inline-block" />
);

const MaxIcon = ({ size = 20 }: { size?: number }) => (
  <img src="/images/Max_logo.svg" alt="MAX" width={size} height={size} className="inline-block" />
);

const socialLinks = [
  { icon: VkIcon, label: 'VK', href: 'https://vk.com/o4ki.ircomp' },
  { icon: MaxIcon, label: 'MAX', href: 'https://max.ru/join/jgM0K2Z4bv69V0W2y-mFAHJa5CfTIOlmkiyvsCvNgRY' },
];

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white mt-auto">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img src="/images/o4kilogo.png" alt="ОЧКИ" className="max-w-full h-auto w-32 md:w-24 lg:w-32 mb-4" />
            <p className="text-gray-300 mb-6 max-w-md">
              Онлайн-чемпионат Югры по креативным индустриям для школьников и студентов.
              Создан АНО ДПО «Институт развития компетенций».
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 bg-gray-800 rounded-full hover:bg-primary-600 transition-colors"
                  aria-label={social.label}
                >
                  <social.icon size={20} />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="text-lg font-semibold mb-4">{category}</h3>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.label}>
                    {link.href.startsWith('http') ? (
                      <a
                        href={link.href}
                        className="text-gray-300 hover:text-white transition-colors"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.href}
                        className="text-gray-300 hover:text-white transition-colors"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="flex items-start space-x-3">
            <MapPin className="h-5 w-5 text-primary-400 mt-1" />
            <div>
              <p className="font-medium">Адрес</p>
              <p className="text-gray-300">г. Сургут, ул. Майская, 10</p>
            </div>
          </div>
          <div className="flex items-start space-x-3">
            <Phone className="h-5 w-5 text-primary-400 mt-1" />
            <div>
              <p className="font-medium">Телефон</p>
              <p className="text-gray-300">+7 (909) 71-22-777</p>
            </div>
          </div>
          <div className="flex items-start space-x-3">
            <Mail className="h-5 w-5 text-primary-400 mt-1" />
            <div>
              <p className="font-medium">Email</p>
              <p className="text-gray-300">info@o4ki.online</p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center text-gray-400 text-sm">
          <p>© 2026 АНО ДПО «Институт развития компетенций». Все права защищены.</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/privacy" className="hover:text-white">
              Политика конфиденциальности
            </Link>
            <Link to="/terms" className="hover:text-white">
              Пользовательское соглашение
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}